<template>
  <div>
    <main>
      <div class="videoSolo">
        <h1 v-if="notAvailable" class="errorHead"> {{ notAvailableMsg }}</h1>
        <div v-if="!notAvailable">
          <div class="clear">
            <div class="votes">
              <div class="wrapper"  @click="onToggleVote">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 510 510" style="enable-background:new 0 0 510 510;" xml:space="preserve">
                <g>
                  <g id="favorite">
                    <path d="M255,489.6l-35.7-35.7C86.7,336.6,0,257.55,0,160.65C0,81.6,61.2,20.4,140.25,20.4c43.35,0,86.7,20.4,114.75,53.55    C283.05,40.8,326.4,20.4,369.75,20.4C448.8,20.4,510,81.6,510,160.65c0,96.9-86.7,175.95-219.3,293.25L255,489.6z" fill="#FFFFFF"/>
                  </g>
                </g>
                </svg>
                {{video.likes}}
              </div>

              <div class="voteModal" v-if="showModal"  >
                <div v-if="!success">
                  <label for="email">Enter your email to cast your vote</label>
                  <input type="text" id="email" v-model="email" @change="onChange">
                  <div class="field-validation-error" v-if="error">{{error}}</div>
                  <Button @click.native="onToggleVote" class="secondary">Cancel</Button>
                  <Button @click.native="onSubmit">Submit</Button>
                </div>
                <div class="success" v-if="success">
                  <h4>Vote submitted</h4>
                  <p>Check your email to confirm your vote.</p>
                  <Button @click.native="onToggleVote" class="secondary">Close</Button>
                </div>
              </div>
            </div>
            <h1>{{video.title}}</h1>

          </div>
          <p>by {{video.author}}</p>

          <div class="videoWrapper">
            <iframe v-if="isYoutube()" :src="'https://www.youtube.com/embed/' + video.link.id" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <iframe v-if="isVimeo()" :src="'https://player.vimeo.com/video/' + video.link.id" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            <iframe v-if="isBiliBili()" :src="'https://player.bilibili.com/player.html?aid=' + video.link.id" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
          </div>
        </div>
        <div class="alignCenter">
          <router-link to="/videos" class="button">View all entries</router-link>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { api } from '@/config'
import getTimeDifference from '@/utils/getTimeDifference'
import axios from 'axios'
import Button from './../components/elements/Button'

export default {
  name: 'Video',
  components: {
    Button
  },
  data() {
    return {
      video: {},
      email: '',
      success: false,
      showModal: false,
      notAvailable: false,
      notAvailableMsg: '',
      error: ''
    }
  },
  mounted() {
    this.changeTheMetaTags()
    document.querySelector('body').style.background = '#2d2d2d'
    if (this.$route.query.id) {
      axios.post(api.video, this.$route.query).then(response => {
        this.video = response.data.data[0]
        this.notAvailable = false
        this.notAvailableMsg = ''
      }).catch((err) => {
        console.log(err)
        this.notAvailable = true
        this.notAvailableMsg = 'Link invalid or this video does not exist.'
      })
    } else {
      this.notAvailable = true
      this.notAvailableMsg = 'Link invalid or this video does not exist.'
    }
  },
  beforeDestroy() {
    document.querySelector('body').style.background = '#fff'
  },
  methods: {
    isYoutube() {
      return this.video.link && this.video.link.service === 'youtube'
    },

    isVimeo() {
      return this.video.link && this.video.link.service === 'vimeo'
    },

    isBiliBili() {
      return this.video.link && this.video.link.service === 'bilibili'
    },

    getTime(date) {
      return getTimeDifference(date)
    },
    onCloseSolo() {
      this.$router.push('videos')
    },
    onToggleVote() {
      this.error = ''
      this.showModal = !this.showModal
    },
    onChange() {
      this.error = ''
    },
    onSubmit() {
      this.error = ''
      if (this.email || this.vide._id) {
        axios.post(api.voteCreate, {
          email: this.email,
          submissionId: this.video._id
        }).then(response => {
          if (response.data.status === 'success') {
            this.success = true
          } else {
            this.error = response.data.errors[0]
          }
        }).catch(err => {
          console.log(err)
          this.error = 'Server error. Try again or contact customer support.'
        })
      } else {
        this.error = 'Server error. Try again or contact customer support.'
      }
    },
    changeTheMetaTags() {
      document.querySelector('meta[property="og:title"]').setAttribute('content', 'Check my submission to the iFootage Creative Video Competition 2019')
    }
  }
}
</script>

<style lang="scss" scoped>
.errorHead {
  color:#fff;
  text-align: center;
}
.button {
  margin-right: 0;
}
button {
  margin-right: 0;
  margin-top: 15px;
  padding: 8px 25px 10px 25px;
  float:right;
  &.secondary {
    float:left;
  }
}
</style>
